import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  id?: string;
};

/** Sanfter Hinweis – blockiert den Buchungsabschluss nicht. */
export function FieldHint({ children, id }: Props) {
  return (
    <p
      id={id}
      className="mt-1.5 rounded-md border border-amber-200 bg-amber-50 px-2.5 py-1.5 text-xs leading-relaxed text-amber-950"
      role="status"
    >
      {children}
    </p>
  );
}
